import { useCallback, useContext } from "react";
import { useQuery } from "react-query";

import { UseQueryProps } from "../../interfaces";
import { apiServiceContext } from "../../api-service-context";
import { QueryKeys } from "../query-keys";

export const useCommentOfUser = <TData = any, TError = any>(
  queryOptions: UseQueryProps<TData, TError> = {}
) => {
  const { commentsApiService } = useContext(apiServiceContext);
  const queryFn = useCallback(
    () =>
      commentsApiService.createCancellableRequest((cancelToken) =>
        commentsApiService.getCommentOfUser(cancelToken)
      ),
    [commentsApiService]
  );

  return useQuery(QueryKeys.commentOfUser(), queryFn, queryOptions);
};
